var map = {
	"./music-instructions.json": 4330,
	"./music-library-intro2024.json": 4331,
	"./music-library-launch2024.json": 4332,
	"./music-progression.json": 4333,
	"./startSourcesAdvanced.json": 4334,
	"./startSourcesSimple.json": 4335,
	"./startSourcesSimple2.json": 4336,
	"./startSourcesTracks.json": 4337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4068;